import { styled } from '@mui/material/styles';
import { Box, Typography, Button } from '@mui/material';

export const Container = styled(Box)(() => ({
  width: '100%',
  padding: '30px 14px 14px 14px',
  maxWidth: '515px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backdropFilter: 'blur(10px)',
  backgroundColor: 'rgba(255, 255, 255, 0.4)',
  border: '1px solid #2D11AD',
  borderRadius: '12px',
}));

export const Title = styled(Typography)({
  fontSize: 'clamp(18px, 5vw, 27px)',
  fontWeight: 700,
  lineHeight: '100%',
  textAlign: 'center',
});

export const Subtitle = styled(Typography)({
  fontSize: 'clamp(12px, 3.36vw, 18px)',
  fontWeight: 500,
  lineHeight: '160%',
  textAlign: 'center',
  marginTop: '34px',
});

export const Btn = styled(Button)(({ theme }) => ({
  wordBreak: 'break-word',
  fontWeight: 600,
  fontSize: 'clamp(16px, 4.4vw, 24px)',
  width: '100%',
  height: '52px',
  maxHeight: '86px',
  borderRadius: 10,
  color: '#fff',
  backgroundColor: '#2D11AD',
  cursor: 'pointer',
  textTransform: 'none',
  padding: 0,
  marginTop: '45px',
  '&:active': {
    transition: '0.1s',
    transform: 'scale(0.99)',
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
  },
}));
